import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeftSidePanel from '@/components/UI/LeftSidePanel';

const TenantSuspendedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-ui-raised">
      <LeftSidePanel />

      <div className="flex-1 flex items-center justify-center bg-ui-raised px-6 py-12">
        <div className="bg-ui-card rounded-2xl shadow-md px-10 py-10 text-center w-full max-w-md">
          <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-6">
            <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8 text-yellow-600" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>

          <h1 className="text-xl font-semibold text-ui-text mb-3">
            {t('suspension.tenantTitle', 'Account Suspended')}
          </h1>

          <p className="text-sm text-ui-text2 mb-2">
            {t('suspension.tenantMessage', 'Your account has been suspended from this tenant.')}
          </p>
          <p className="text-sm text-ui-text3 mb-8">
            {t('suspension.contactAdmin', 'Please contact your tenant administrator to restore access.')}
          </p>

          <button
            onClick={() => navigate('/login')}
            className="w-full py-2.5 rounded-lg bg-brand-dark text-white text-sm font-medium hover:opacity-90 transition"
          >
            {t('auth.backToLogin', 'Back to Login')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantSuspendedPage;
